import { UzButton, UzDialog } from '@utazzo/ui';
import React, { useState } from 'react';

import { localTodayISO } from '@/lib/date-format';

interface GstInvoicePaidDialogProps {
  open: boolean;
  /** What is being marked paid, e.g. the invoice number. */
  subject: string;
  pending?: boolean;
  onConfirm: (values: { paidAt: string }) => void;
  onCancel: () => void;
}

/** Captures the payment date when marking a single invoice's GST as paid. */
export const GstInvoicePaidDialog = ({
  open,
  subject,
  pending,
  onConfirm,
  onCancel,
}: GstInvoicePaidDialogProps): React.JSX.Element => {
  const [paidAt, setPaidAt] = useState(localTodayISO());

  return (
    <UzDialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onCancel();
      }}
      title="Mark GST as paid"
      description={`${subject}. Enter the date the GST was paid.`}
      size="md"
      footer={
        <div className="flex justify-end gap-2">
          <UzButton variant="ghost" onClick={onCancel}>
            Cancel
          </UzButton>
          <UzButton loading={pending} disabled={!paidAt} onClick={() => onConfirm({ paidAt })}>
            Mark paid
          </UzButton>
        </div>
      }
    >
      <div>
        <label htmlFor="gst-inv-paid-at" className="mb-1 block text-sm font-medium text-zinc-700">
          Payment date
        </label>
        <input
          id="gst-inv-paid-at"
          type="date"
          value={paidAt}
          onChange={(e) => setPaidAt(e.target.value)}
          className="border-input focus-visible:ring-ring flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:ring-1 focus-visible:outline-none"
        />
      </div>
    </UzDialog>
  );
};
